export function getDevice() {
  return 'browser';
}
